import './loginModal.css';
import '../../styles/global.css';
import '../UI/ui.css';
import { createModal } from '../UI/Modal.js';
import { authStore } from '../../store/auth.store.js';
import { login } from '../../api/auth.js';
import { showToast } from '../UI/Toast.js';
import { validateEmail, validatePassword, } from '../../utils/validators.js';
export function createLoginModal() {
    const content = document.createElement('div');
    let isLoading = false;
    const render = () => {
        content.innerHTML = `
      <div class="login-form">
        <div class="form-group">
          <label class="form-label" for="login-email">Email</label>
          <input
            class="form-input"
            id="login-email"
            type="email"
            placeholder="admin@amaze.gg"
            autocomplete="email"
            ${isLoading ? 'disabled' : ''}
          />
          <span class="form-error" id="email-error"></span>
        </div>

        <div class="form-group">
          <label class="form-label" for="login-password">Password</label>
          <input
            class="form-input"
            id="login-password"
            type="password"
            placeholder="••••••••"
            autocomplete="current-password"
            ${isLoading ? 'disabled' : ''}
          />
          <span class="form-error" id="password-error"></span>
        </div>

        <div class="login-actions">
          <button class="btn btn-primary" id="login-submit" ${isLoading ? 'disabled' : ''}>
            ${isLoading ? '<div class="login-spinner"></div>' : 'Sign In'}
          </button>
        </div>
      </div>
    `;
        const form = content.querySelector('.login-form');
        const emailInput = content.querySelector('#login-email');
        const passwordInput = content.querySelector('#login-password');
        const submitBtn = content.querySelector('#login-submit');
        const showError = (id, msg) => {
            const el = content.querySelector(`#${id}`);
            if (el)
                el.textContent = msg;
        };
        const clearError = (id) => showError(id, '');
        emailInput.addEventListener('input', () => clearError('email-error'));
        passwordInput.addEventListener('input', () => clearError('password-error'));
        const handleSubmit = async () => {
            const email = emailInput.value.trim();
            const password = passwordInput.value;
            const emailErr = validateEmail(email);
            const passwordErr = validatePassword(password);
            if (emailErr) {
                showError('email-error', emailErr);
                emailInput.classList.add('error');
                return;
            }
            if (passwordErr) {
                showError('password-error', passwordErr);
                passwordInput.classList.add('error');
                return;
            }
            isLoading = true;
            render();
            try {
                const result = await login(email, password);
                authStore.setAuth(result.token, result.profile);
                showToast({ message: `Welcome back, ${result.profile.username}!`, type: 'success' });
                modal.close();
            }
            catch (err) {
                isLoading = false;
                showToast({ message: err.message ?? 'Login failed', type: 'error' });
                render();
            }
        };
        submitBtn.addEventListener('click', handleSubmit);
        form.addEventListener('keydown', (e) => {
            if (e.key === 'Enter')
                handleSubmit();
        });
    };
    render();
    const modal = createModal({
        title: 'Admin Sign In',
        content,
    });
    return modal;
}
